<template lang="pug">
	.emitter-settings(v-if="showed && emitter")
		.card
			.card-header
				i.fa.fa-edit
				span Emitter Settings
			.card-body.collapse.show
				.form-line.separator
					.form-group
						label.col-form-label.controls-title Emitter name
						.controls
							input.form-control.title(size="16" type="text" v-model="title" @change="updateName")
					.form-group.bottom-align
						.editor-types
							.editor-type.properties(:class="{selected: mode === 'intensity'}" @click="mode = 'intensity'")
								.title Intensity
								i.fa.fa-sliders
							.editor-type-separator
							.editor-type(:class="{selected: mode === 'position'}" @click="mode = 'position'")
								.title Position
								i.fa.fa-arrows
							.editor-type-separator
							.editor-type(:class="{selected: mode === 'scale'}" @click="mode = 'scale'")
								.title Scale
								i.fa.fa-arrows-h(:style="{transform: 'rotate(-45deg)', transformOrigin: '6px 6px 0px'}")
							.editor-type-separator
							.editor-type(:class="{selected: mode === 'rotation'}" @click="mode = 'rotation'")
								.title Rotation
								i.fa.fa-repeat
							.editor-type-separator
							.editor-type(:class="{selected: mode === 'alpha'}" @click="mode = 'alpha'")
								.title Alpha
								i.fa.fa-star-half-o
				.properties-content.separator(v-if="mode === 'intensity'")
					.form-line
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['duration']['title']}}
							InputNumberDrag(v-on:change="setEmitterProperty('duration', $event)" :default="Metadata.EmitterPropertiesByCodename['duration']['default']" :value="emitter.props.duration" :options="Metadata.EmitterPropertiesByCodename['duration']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['wavesPerSecond']['title']}}
							InputNumberDrag(v-on:change="setEmitterProperty('wavesPerSecond', $event)" :default="Metadata.EmitterPropertiesByCodename['wavesPerSecond']['default']" :value="emitter.props.wavesPerSecond" :options="Metadata.EmitterPropertiesByCodename['wavesPerSecond']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['particlesCountPerWave']['title']}}
							InputNumberDrag(v-on:change="setEmitterProperty('particlesCountPerWave', $event)" :default="Metadata.EmitterPropertiesByCodename['particlesCountPerWave']['default']" :value="emitter.props.particlesCountPerWave" :options="Metadata.EmitterPropertiesByCodename['particlesCountPerWave']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['appearanceOrder']['title']}}
							Select(v-on:change="setEmitterProperty('appearanceOrder', $event, 0)" :default="Metadata.EmitterPropertiesByCodename['appearanceOrder']['default']" :value="emitter.props.appearanceOrder" :values="Metadata.EmitterPropertiesByCodename['appearanceOrder']['options']['values']" :type="Metadata.EmitterPropertiesByCodename['appearanceOrder']['type']")
					.form-line
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['particleLifetime']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('particleLifetime', $event)" :default="Metadata.EmitterPropertiesByCodename['particleLifetime']['default']" :value="emitter.props.particleLifetime" :options="Metadata.EmitterPropertiesByCodename['particleLifetime']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['maxParticles']['title']}}
							InputNumberDrag(v-on:change="setEmitterProperty('maxParticles', $event)" :default="Metadata.EmitterPropertiesByCodename['maxParticles']['default']" :value="emitter.props.maxParticles" :options="Metadata.EmitterPropertiesByCodename['maxParticles']['options']")
				.properties-content.separator(v-if="mode === 'position'")
					.form-line
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['spawnAreaType']['title']}}
							Select(v-on:change="setEmitterProperty('spawnAreaType', $event, 0)" :default="Metadata.EmitterPropertiesByCodename['spawnAreaType']['default']" :value="emitter.props.spawnAreaType" :values="Metadata.EmitterPropertiesByCodename['spawnAreaType']['options']['values']" :type="Metadata.EmitterPropertiesByCodename['spawnAreaType']['type']")
						.form-group(v-if="emitter.props.spawnAreaType === 'ellipse'")
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['spawnEllipseDetails']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('spawnEllipseDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['spawnEllipseDetails']['default']" :value="emitter.props.spawnEllipseDetails" :options="Metadata.EmitterPropertiesByCodename['spawnEllipseDetails']['options']")
						.form-group(v-if="emitter.props.spawnAreaType === 'point'")
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['spawnPointDetails']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('spawnPointDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['spawnPointDetails']['default']" :value="emitter.props.spawnPointDetails" :options="Metadata.EmitterPropertiesByCodename['spawnPointDetails']['options']")
						.form-group(v-if="emitter.props.spawnAreaType === 'line'")
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['spawnLineDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('spawnLineDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['spawnLineDetails']['default']" :value="emitter.props.spawnLineDetails" :options="Metadata.EmitterPropertiesByCodename['spawnLineDetails']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['gravity']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('gravity', $event)" :default="Metadata.EmitterPropertiesByCodename['gravity']['default']" :value="emitter.props.gravity" :options="Metadata.EmitterPropertiesByCodename['gravity']['options']")
					.form-line
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['endPositionType']['title']}}
							Select(v-on:change="setEmitterProperty('endPositionType', $event, 0)" :default="Metadata.EmitterPropertiesByCodename['endPositionType']['default']" :value="emitter.props.endPositionType" :values="Metadata.EmitterPropertiesByCodename['endPositionType']['options']['values']" :type="Metadata.EmitterPropertiesByCodename['endPositionType']['type']")
						.form-group(v-if="emitter.props.endPositionType === 'relative-spawn'")
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['moveSpawnDetails']['title']") {{Metadata.EmitterPropertiesByCodename['moveSpawnDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('moveSpawnDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['moveSpawnDetails']['default']" :value="emitter.props.moveSpawnDetails" :options="Metadata.EmitterPropertiesByCodename['moveSpawnDetails']['options']")
						.form-group(v-if="emitter.props.endPositionType === 'relative-center'")
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['moveCenterDetails']['title']") {{Metadata.EmitterPropertiesByCodename['moveCenterDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('moveCenterDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['moveCenterDetails']['default']" :value="emitter.props.moveCenterDetails" :options="Metadata.EmitterPropertiesByCodename['moveCenterDetails']['options']")
						.form-group(v-if="emitter.props.endPositionType === 'specific-point'")
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['movePointDetails']['title']") {{Metadata.EmitterPropertiesByCodename['movePointDetails']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('movePointDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['movePointDetails']['default']" :value="emitter.props.movePointDetails" :options="Metadata.EmitterPropertiesByCodename['movePointDetails']['options']")
						.form-group(v-if="emitter.props.endPositionType === 'multiply'")
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['moveMultiplyDetails']['title']") {{Metadata.EmitterPropertiesByCodename['moveMultiplyDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('moveMultiplyDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['moveMultiplyDetails']['default']" :value="emitter.props.moveMultiplyDetails" :options="Metadata.EmitterPropertiesByCodename['moveMultiplyDetails']['options']")
						.form-group(v-if="emitter.props.endPositionType === 'based-on-speed'")
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['moveSpeedDetails']['title']")  {{Metadata.EmitterPropertiesByCodename['moveSpeedDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('moveSpeedDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['moveSpeedDetails']['default']" :value="emitter.props.moveSpeedDetails" :options="Metadata.EmitterPropertiesByCodename['moveSpeedDetails']['options']")
				.properties-content.separator(v-if="mode === 'scale'")
					.form-line
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['startScale']['title']") {{Metadata.EmitterPropertiesByCodename['startScale']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('startScale', $event)" :default="Metadata.EmitterPropertiesByCodename['startScale']['default']" :value="emitter.props.startScale" :options="Metadata.EmitterPropertiesByCodename['startScale']['options']")
					.form-line
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['scaleSpeedDetails']['title']") {{Metadata.EmitterPropertiesByCodename['scaleSpeedDetails']['title']}}
							InputCoordsList(v-on:change="setEmitterProperty('scaleSpeedDetails', $event)" :default="Metadata.EmitterPropertiesByCodename['scaleSpeedDetails']['default']" :value="emitter.props.scaleSpeedDetails" :options="Metadata.EmitterPropertiesByCodename['scaleSpeedDetails']['options']")
				.properties-content.separator(v-if="mode === 'rotation'")
					.form-line
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['startRotation']['title']") {{Metadata.EmitterPropertiesByCodename['startRotation']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('startRotation', $event)" :default="Metadata.EmitterPropertiesByCodename['startRotation']['default']" :value="emitter.props.startRotation" :options="Metadata.EmitterPropertiesByCodename['startRotation']['options']")
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['rotationSpeed']['title']") {{Metadata.EmitterPropertiesByCodename['rotationSpeed']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('rotationSpeed', $event)" :default="Metadata.EmitterPropertiesByCodename['rotationSpeed']['default']" :value="emitter.props.rotationSpeed" :options="Metadata.EmitterPropertiesByCodename['rotationSpeed']['options']")
				.properties-content.separator(v-if="mode === 'alpha'")
					.form-line
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['startAlpha']['title']") {{Metadata.EmitterPropertiesByCodename['startAlpha']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('startAlpha', $event)" :default="Metadata.EmitterPropertiesByCodename['startAlpha']['default']" :value="emitter.props.startAlpha" :options="Metadata.EmitterPropertiesByCodename['startAlpha']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['alphaSpeed']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('alphaSpeed', $event)" :default="Metadata.EmitterPropertiesByCodename['alphaSpeed']['default']" :value="emitter.props.alphaSpeed" :options="Metadata.EmitterPropertiesByCodename['alphaSpeed']['options']")
					.form-line
						.form-group
							label.col-form-label.controls-title(v-if="Metadata.EmitterPropertiesByCodename['endAlpha']['title']") {{Metadata.EmitterPropertiesByCodename['endAlpha']['title']}}
							InputCoordsDrag(v-on:change="setEmitterProperty('endAlpha', $event)" :default="Metadata.EmitterPropertiesByCodename['endAlpha']['default']" :value="emitter.props.endAlpha" :options="Metadata.EmitterPropertiesByCodename['endAlpha']['options']")
						.form-group
							label.col-form-label.controls-title {{Metadata.EmitterPropertiesByCodename['fadeTime']['title']}}
							InputNumberDrag(v-on:change="setEmitterProperty('fadeTime', $event)" :default="Metadata.EmitterPropertiesByCodename['fadeTime']['default']" :value="emitter.props.fadeTime" :options="Metadata.EmitterPropertiesByCodename['fadeTime']['options']")
				.form-actions
					button.btn.btn-danger(type="button" @click="deleteEmitter()" v-b-tooltip.hover.v-danger="{delay: { show: 500, hide: 100 }, title: 'Delete emitter'}")
						i.fa.fa-remove
						span Delete
					button.btn.btn-dark(type="button" @click="hide()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen';

	import { Creative } 			from '../../services/Creative';
	import { Version } 			from '../../services/Version';
	import { Settings } 		from '../../services/Settings';
	import { Events } 			from '../../services/Events';

	import InputNumberDrag		from './../Editor/Controls/InputNumberDrag'
	import InputCoordsDrag		from './../Editor/Controls/InputCoordsDrag'
	import InputCoordsList		from './../Editor/Controls/InputCoordsList'
	import Select				from './../Editor/Controls/Select'

	export default {
		name: "EmitterSettings",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Element Emitter Changed"
			],
			events: {
				"Show Emitter Settings": function(emitter) {

					this.emitter = emitter;

					this.show();

				}
			}
		},
		components: {
			InputNumberDrag,
			InputCoordsDrag,
			InputCoordsList,
			Select
		},
		data() {

			this.Creative = Creative;
			this.Version = Version;
			this.Settings = Settings;

			this.emitter = null;

			return {
				title: '',
				count: 0,
				mode: 'intensity'
			}
		},
		methods: {
			collectData() {

				this.emitter = Emitter.EmittersById[this.emitter.id];
				this.version = Version.SelectedVersion;
				this.title = this.emitter.title;

				this.count++;

			},
			updateName() {

				Server.sendWithTimeout({
					RenameEmitter: {
						emitterId: this.emitter.id,
						title: this.title.trim()
					}
				}, null, 200);

			},
			addPlayOnEvent(emitter, data) {

				let playOn = _.cloneDeep(emitter.props.playOn || []);
				playOn.push(data.eventCodename);

				Server.sendToSocket({
					SetEmitterProperty: {
						emitterId: emitter.id,
						emitterPropertyCodename: 'playOn',
						emitterPropertyValue: playOn,
					}
				});

			},
			removePlayOnEvent(emitter, eventCodename) {

				let playOn = _.cloneDeep(emitter.props.playOn || []);
				playOn = _.without(playOn, eventCodename);

				Server.sendToSocket({
					SetEmitterProperty: {
						emitterId: emitter.id,
						emitterPropertyCodename: 'playOn',
						emitterPropertyValue: playOn,
					}
				});

			},
			setEmitterProperty(propertyName, value, timeout = 1000) {

				console.log('setEmitterProperty', propertyName, value);

				Server.sendWithTimeout({
					SetEmitterProperty: {
						emitterId: this.emitter.id,
						emitterPropertyCodename: propertyName,
						emitterPropertyValue: value,
					}
				}, `${this.emitter['version_id']}:${this.emitter['screen_codename']}:${this.emitter['element_codename']}:${this.emitter.codename}:${propertyName}`, timeout);

			},
			deleteEmitter() {

				//Broadcast.call("Show CreativeDelete", []);

				this.hide();

			}
		}
	}
</script>


<style lang="sass">

	.emitter-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 900px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			input.title
				width: 260px

			.btn-danger, .btn-primary
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.controls-title
				padding-left: 2px
				padding-bottom: 0
				margin-bottom: 5px

		.form-group
			display: flex
			flex-direction: column
			margin-left: 40px

			&:first-child
				margin-left: 0

			&.bottom-align
				align-self: flex-end

		.properties-content
			height: 200px

		.form-line
			display: flex
			flex-direction: row

		.form-actions
			margin-top: 20px

		.editor-types
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: space-between
			align-items: center
			border: 1px solid #23282c
			border-radius: 4px
			user-select: none
			background: rgba(255, 255, 255, 0.05) no-repeat

			.editor-type
				border: 1px solid transparent
				border-radius: 4px
				padding-top: 4px
				padding-bottom: 4px
				padding-right: 0.75rem
				padding-left: 0.75rem
				color: #73818f
				cursor: pointer
				font-size: 13px
				text-transform: uppercase
				display: flex
				flex-direction: row-reverse
				justify-content: center
				align-items: center
				width: 100%
				height: 33px

				.title
					padding-left: 7px
					padding-right: 1px

				i.fa
					margin-top: 2px

			.editor-type:hover
				//border: 1px solid #fff
				//background: rgba(255, 255, 255, 0.1) no-repeat

				.title, i.fa
					color: #c1d3e4

			.editor-type.selected
				border: 1px solid #2ac0f3
				background: rgba(255, 255, 255, 0.1) no-repeat

				.title, i.fa
					color: #2ac0f3

			.editor-type-separator
				width: 0
				height: 100%
				border-right: 1px solid rgba(0, 0, 0, 0.1)

</style>

